import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type Props = ApiMethodBase & {}

export const setAction_Analytics = ({ eventEmitter }: Props) => {
    apiProvider.setActiveAction({action: 'performance_analytics'})
    eventEmitter.emit(Event.setActionBar_Analytics);
};
